<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Car Wash &amp; External Protection</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                How often you should wash your car depends on various factors such as weather 
                conditions, driving habits, and environmental factors. However, as a general 
                guideline, it's recommended to wash your car every 2-4 weeks under 
                normal conditions. 
            </h1>
            
            <p>
                Here's why it's important:
            </p>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    <span class="dark:text-white">Preservation of Paint and Finish:</span> 
                    Regular washing helps to remove dirt, grime, and environmental contaminants 
                    from the surface of your car. These contaminants can be abrasive and may 
                    cause scratches or swirl marks if left on the paint for an extended period.
                </p>

                <p>
                    <span class="dark:text-white">Protection Against Corrosion:</span> 
                    Bird droppings and other contaminants can be corrosive to your car's paint 
                    and metal surfaces. Regular washing helps to remove these corrosive substances, 
                    reducing the risk of rust and corrosion.
                </p>        

                <p>
                    <span class="dark:text-white">Improved Visibility and Safety:</span> 
                    A clean windshield and windows provide better visibility while driving, especially 
                    during adverse weather conditions such as rain or fog.
                </p>

                <p>
                    <span class="dark:text-white">Improved Resale Value:</span> 
                    A well-maintained and clean car typically commands a higher resale value. 
                    Regular washing and detailing help to preserve the appearance of your vehicle, 
                    making it more attractive to potential buyers when it comes time to 
                    sell or trade in.
                </p>        

            </div>

        </div>

    </div>   
    
</template>
